<template>
	<Col class="width-100 flex-justify-center px-5">
		<h5 class="get-link mb-2">Get link</h5>
		<LinkCopy class="ma-0 mb-5" :src="workflow.run_link" />
		<MaybeUpgradeRequiredIndicator :billingFeatureId="billingFeatureId">
			<template #default="{ indicator, isUpgradeRequired }">
				<Row>
					<h3
						v-if="isCustomDomainsEnabled"
						@click="(e) => customizeURL(e, isUpgradeRequired, indicator)"
						class="link purple-text fit-content"
					>
						Customize URL
					</h3>
					<div class="pl-2" v-if="billingFeatureId && isUpgradeRequired">
						<component :is="indicator" :billingFeatureId="billingFeatureId" iconOnly />
					</div>
				</Row>
			</template>
		</MaybeUpgradeRequiredIndicator>
	</Col>
</template>
<script>
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import LinkCopy from '@/components/common/LinkCopy/LinkCopy.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { isCustomDomainsEnabled } from '@/store/modules/featureFlags/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'ShareDialogToolDetails',
	components: { LinkCopy, MaybeUpgradeRequiredIndicator },
	props: { workflow: { type: Object } },
	methods: {
		customizeURL(e, isUpgradeRequired, indicator) {
			if (isUpgradeRequired && indicator?.setup) {
				indicator.setup().openUpgrade(null, this.billingFeatureId);
			} else {
				AppDialogManagerService.openSetCustomDomainForWorkflowDialog({
					workflow: this.workflow,
					plyLink: this.workflow.ply_run_link,
				});
			}
		},
	},
	computed: {
		...mapGettersShorthand({ isCustomDomainsEnabled }),
		billingFeatureId() {
			return FeatureTypes.CustomerCustomDomains;
		},
	},
};
</script>
<style scoped lang="scss">
.get-link {
	color: #2c2b2c;
	font-weight: 600;
	letter-spacing: 0px;
}
.purple-text {
	color: #6162d8;
}
</style>
